export default __webpack_public_path__ + "static/photoHero-1dc7ec77c3230a1ddf1dc75565c79a74.png";